/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getQuotations } from "api/services/quoteRequest";
import { useCustomQuery } from "hooks/useCustomQuery";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

type GetQuotationsOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetQuotations = (data: GetQuotationsOptions) =>
  useCustomQuery<any>({
    queryKey: quoteRequestQueryKeys.quoteQuotationListing(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getQuotations(data.shipmentId).then((res) => res.data),
    ...data.options,
  });
